import PortfolioLiveContainer from "./PortfolioLive.styles";
import PowerBIDashboard from "../../components/Common/PowerBIDashboard";

type Props = {};

export default function PortfolioLiveLight({}: Props) {
    return (
        <PortfolioLiveContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="d5ebd43f-d3f9-4724-b8ca-78d53e8503f1"
                    workspaceId="c9679fac-e043-4b12-b47b-d350f81543c1"
                ></PowerBIDashboard>
            </div>
        </PortfolioLiveContainer>
    );
}
